<template>
  <!-- 用户详情-充值记录 -->
  <div>
    <el-form :inline="true" :model="query" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="query.user_id" placeholder="user_id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.status" placeholder="状态">
          <el-option :value="undefined">全部</el-option>
          <el-option :value="0" label="未审核"></el-option>
          <el-option :value="1" label="已审核"></el-option>
          <el-option :value="2" label="已退回"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-col class="pull-left" style="width: 220px; margin-right: 20px">
          <el-date-picker
              v-model="query.start_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="起始时间"
          >
          </el-date-picker>
        </el-col>
        <el-col class="pull-left" style="width: 220px; margin-right: 20px">
          <el-date-picker
              v-model="query.end_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="起始时间"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getTableData">确定</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="user_id" label="user_id" width="240px"></el-table-column>
      <el-table-column prop="user.name" label="用户名" width="240px"></el-table-column>
      <el-table-column prop="amount" label="金额" width="240px"></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column prop="created_at" label="时间" sortable></el-table-column>
      <el-table-column prop="status" label="状态" :filters="[
        { text: '未审核', value: 0 },
        { text: '已审核', value: 1 },
        { text: '已退回', value: 2 },
      ]" :filter-method="filterStatus">
        <template slot-scope="{ row }">
          <span v-if="row.status === 0">未审核</span>
          <span v-if="row.status === 1">已审核</span>
          <span v-if="row.status === 2">已退回</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350px">
        <template slot-scope="{ row }">
          <el-row v-if="row.status == 0">
            <el-button type="primary" @click="setStatus(row, 1)"
            >通过
            </el-button>
            <el-button type="primary" plain @click="setStatus(row, 2)"
            >退回
            </el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
      :current-page="query.page" @current-change="handlePageChange"></el-pagination>
  </div>
</template>

<script>
import {getData, patchData} from '../../http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,
      query: {//查询条件
        page: 1,
        user_id: undefined,
        status: undefined,
        start_time: undefined,
        end_time: undefined,
      },
      dataList: undefined,
      dataMeta: {},
    }
  },

  methods: {
    getTableData() {
      this.loading = true
      let params = this.query
      getData(`extract_m9_log`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    setStatus(row, status) {
      let params = {
        id: row.id,
        status: status
      }
      patchData(`set_extract_m9`, params)
        .then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.visibleChange = false
            this.getTableData()
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    filterPayType(value, row, column) {
      //筛选充值方式
      const property = column['property'];
      return row[property] === value;
    },
    filterStatus(value, row, column) {
      //筛选订单状态
      const property = column['property'];
      return row[property] === value;
    },
    handlePageChange(page) {
      this.query.page = page
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>

</style>
